import { pickBy, isEmpty, isNumber } from "lodash";

export default {
  data() {
    return {
      pagesize: [10, 20, 50, 100],
      pagination: {
        currentPage: 1,
        totalCount: 0,
        pageSize: 10,
      },
      filterObj: {},
    };
  },
  provide() {
    return {
      handleSizeChange: this.handleSizeChange,
      handleCurrentChange: this.handleCurrentChange,
    };
  },
  methods: {
    search() {
      this.restPagination();
      this.fetch();
    },
    fetch() {},
    customRest() {},
    defaultRest() {
      let typeDefaultValue = {
        "[object Array]": [],
        "[object String]": "",
      };
      for (let key in this.filterObj) {
        let value = this.filterObj[key];
        let newValue =
          typeDefaultValue[Object.prototype.toString.call(value)] || "";
        this.filterObj[key] = newValue;
      }
      this.customRest();
      this.restPagination();
    },
    restPagination() {
      this.pagination = {
        currentPage: 1,
        totalCount: 0,
        pageSize: this.pagination.pageSize,
      };
    },
    reset() {
      this.defaultRest();
      this.fetch();
    },
    // 获取筛选条件
    getFilterParams() {
      const data = pickBy(
        this.filterObj,
        (v) => !isEmpty(v) || (isNumber(v) && parseInt(v))
      );
      return data;
    },
    handleSizeChange(size) {
      this.pagination.pageSize = size;
      this.fetch();
    },
    handleCurrentChange(currentPage) {
      this.pagination.currentPage = currentPage;
      this.fetch();
    },
    // 获取自定义表单内容类型
    getFormItemType() {
      return {
        INPUT: "INPUT",
        CASCADER: "CASCADER",
        SELECT: "SELECT",
        TEXTAREA: "TEXTAREA",
        INPUT_NUMBER: "INPUT_NUMBER",
        DATE: "DATE",
        DATETIME_RRANGE: "DATETIME_RRANGE",
        CONTRAST_INPUT: "CONTRAST_INPUT",
        CONTRAST_DATETIME_RRANGE: "CONTRAST_DATETIME_RRANGE",
        DATE_RANGE: "DATE_RANGE",
      };
    },
  },
};
